module.exports = __webpack_public_path__ + "static/right-flower-6d15f82058b7000ec82c1ad166d7a828.png";